export function durationFormatter(minutes) {
  if (minutes <= 60) {
    return `${minutes}mn`;
  }

  let mod = minutes % 60;

  return `${Math.floor(minutes / 60)}h ${mod ? `${mod}mn` : ""}`;
}
